/* eslint-disable jira/filename-case */
export const debugEnabled = (flag: string): boolean =>
	(process.env.JFE_DEBUG || '').split(',').includes(flag);
